import { createAction } from '@reduxjs/toolkit';

export const [createNotification, removeNotification] = [
  createAction('CREATE_NOTIFICATION'),
  createAction('REMOVE_NOTIFICATION'),
];
